import { render, staticRenderFns } from "./CustomersDataSheet.vue?vue&type=template&id=48d68b69&"
import script from "./CustomersDataSheet.vue?vue&type=script&lang=js&"
export * from "./CustomersDataSheet.vue?vue&type=script&lang=js&"
import style0 from "./CustomersDataSheet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports